export default __webpack_public_path__ + "static/media/leonardo.80df386c.png";